import { render } from "./edit-product-modal.vue?vue&type=template&id=07534d23&scoped=true"
import script from "./edit-product-modal.vue?vue&type=script&lang=js"
export * from "./edit-product-modal.vue?vue&type=script&lang=js"

import "./edit-product-modal.vue?vue&type=style&index=0&id=07534d23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07534d23"]])

export default __exports__